import locale from '@com/core/common/utils/locale';
import { DOMAIN, ENV } from '@com/core/common/baseConfig';
import { getAppConfig } from './config';
import { TLocaleISO } from '../types/locale';

const isBrowser: boolean = typeof window !== 'undefined';
export type TApp =
    | 'dev'
    | 'www'
    | 'www-alt'
    | 'account'
    | 'account-alt'
    | 'checkout'
    | 'checkout-alt'
    | 'login'
    | 'login-alt'
    | 'ofd'
    | 'ofd-alt'
    | 'shipments'
    | 'shipments-alt';

export const formattedRedirectUrl = (isoLocale: TLocaleISO, app: TApp, path: string): string => {
    let currentDomain = DOMAIN;
    const currentPort = '';
    // after deployment for staging env the DOMAIN supplied
    // is incorrect and this will ensure we're redirecting
    // to the proper domain
    if (isBrowser) {
        const [, domain] = window.location.hostname.split('.');
        if (domain) {
            currentDomain = domain;
        }
    }

    return `https://${app}.${currentDomain}.com${currentPort}/${locale.getSEOLocale(isoLocale)}/${path || ''}`;
};

export const redirect = (isoLocale: TLocaleISO, path = '', app: TApp = 'www'): void => {
    let redirectURL = '';
    let appLocation = app;
    if (isBrowser) {
        const urlSegments = window.location.hostname.split('.');
        const isAlt = urlSegments[0].includes('-alt');
        appLocation = isAlt ? (`${appLocation}-alt` as TApp) : appLocation;
    }
    redirectURL = formattedRedirectUrl(isoLocale, appLocation, path);
    window.location.href = redirectURL;
    const [, domain] = redirectURL.split('.');
    if (DOMAIN === domain) {
        window.location.href = redirectURL;
    }
};

export const isExternalLink = (url = ''): boolean => {
    const sanitizedUrl = url.trim().toLowerCase();
    return ['http', 'www'].reduce((itDoes, thisThing) => itDoes || sanitizedUrl.startsWith(thisThing), false);
};

export const setBrowserState = (url: string, replaceState = false): void => {
    if (!isBrowser) return;

    const title = 'noon';

    if (replaceState) {
        // eslint-disable-next-line no-restricted-globals
        history.replaceState({}, title, url);
    } else {
        // eslint-disable-next-line no-restricted-globals
        history.pushState({}, title, url);
    }
};

export const removeStartingSlash = (href = ''): string => {
    if (href.startsWith('/')) {
        return href.slice(1);
    }
    return href;
};

export const getPageForPath = async (href = ''): Promise<string> => {
    const { routes } = await getAppConfig();
    const defaultRoute = { page: '/' };
    const { page } = routes.find(({ pathMatch }) => pathMatch.test(href)) || defaultRoute;
    return page;
};
